










import _ from "lodash";
import {Component} from "vue-property-decorator";
import Loading from "@/components/Loading.vue";
import VueError from "@/components/VueError.vue";
import Spinner from "@/components/Spinner.vue";

import {BssService, curBssService} from "@/services/BssService";
import {TrafficStatsTimeSeriesPoint} from "@/services/CoreClient";
import KeyValue from "@/components/KeyValue.vue";
import BaseStationBarChart from "@/components/bss/BaseStationBarChart.vue";
import {ChartItem} from "chart.js";



@Component({
  components:{
    KeyValue,
    Loading,
    VueError,
    Spinner
  }
})
export default class BaseStationTrafficChart extends BaseStationBarChart {
  private bssService:BssService = curBssService;

  get id(): string {
    return `base-station-traffic-chart-canvas-${this.lrrId}-${this.timeType}`;
  }

  mounted() {
    const ctx = document.getElementById(this.id);
    this.createChart(ctx as ChartItem);
  }

  protected async fetchChartDataImpl(lrrId: string,
                                     start: number,
                                     finish: number,
                                     interval: number,
                                     timeType: string): Promise<any> {
    const dataFromDl = await this.getBaseStationTraffic(lrrId,
        start,
        finish,
        interval,
        timeType);
    const ret = {
      labels: _.map(dataFromDl, item => item.ts),
      datasets: [{
        categoryPercentage: 1.0,
        barPercentage: .9,
        label: 'uplinks',
        backgroundColor: '#20c997',
        stack: 'one',
        data: _.map(dataFromDl, item => item.uplinks)
      }, {
        categoryPercentage: 1.0,
        barPercentage: .9,
        label: 'downlinks',
        backgroundColor: '#d2f4f9',
        stack: 'one',
        data: _.map(dataFromDl, item => item.downlinks)
      }],
    };
    return ret;
  }

  protected calcIntervalFromStartFinish(startSec: number, finishSec: number): number {
    const rangeAsNumberOfHours = Math.floor((finishSec - startSec) / 3600 );
    let intervalSec = 60;
    if ( rangeAsNumberOfHours > 5 * 24 ) {
      intervalSec = 24 * 3600;
    } else if ( rangeAsNumberOfHours >= 12 ) {
      intervalSec = 3600;
    }
    return intervalSec;
  }

  async getBaseStationTraffic(lrrId:string,
                              start: number,
                              finish: number,
                              interval: number,
                              timeType: string):Promise<TrafficStatsTimeSeriesPoint[]> {
    const reply = await this.bssService.getBaseStationTrafficTimeSeries({
      lrrId,
      start,
      finish,
      interval,
      timeType,
    });
    return Promise.resolve(reply.timeSeries as TrafficStatsTimeSeriesPoint[]);
  }
}
